<template>
  <section class="section pt-5">
    <tickets-datatable />
  </section>
</template>

<script>
import TicketsDataTable from "./tickets_datatable/Index.vue";

export default {
  name: "HelpdeskTickets",
  components: {
    "tickets-datatable": TicketsDataTable,
  },
};
</script>
